import React from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayout from "../layouts/footer.layout";
import banner from "../styles/images/banner_contacto.webp";
import FormComponent from "../components/contacto/form.component";
import TitleComponent from "../components/contacto/description.component";
/*eslint-disable */
const ContactoPage: React.FC = () => {
  return (
    <>
      <MenuLayouts />
      <div className="page-title-area" style={{backgroundImage: `URL(${banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
        <div className="container">
          <div className="page-title-content">
            <h1 style={{color: "#fff"}}>Contacto</h1>
          </div>
        </div>
      </div>
      <TitleComponent />
      <FormComponent />
      <FooterLayout />
    </>
  );
};

export default ContactoPage;
